var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/**
 * Adapts the legacy `@components/Table` column shape to the `@ui` one.
 *
 * The two already agree on everything that matters — `label`, `dataKey`, `align`, and a
 * `renderer({ item })` that returns JSX. Two things do not carry over:
 *
 * - **`width` is dropped.** The legacy table treats it as a proportional hint; `@ui`'s applies it
 *   as a CSS length. These columns declare 240 + 416 + 416 + 150, which fits the legacy table and
 *   overflows the `@ui` one inside a nested accordion — measured 2026-10-27, Review Status and the
 *   row actions were pushed outside the container. The `@ui` Table sizes columns from content,
 *   which is how its own accordion-grouped story uses it.
 * - **The renderer's `key` param.** `@ui` does not pass one and no renderer on this screen reads
 *   it, so it is synthesised from the row index rather than changing every signature.
 *
 * This is an adapter rather than a second column list because `getDocumentColumns` is still the
 * single definition of what the Documents tab shows, and the flag-OFF path keeps rendering it
 * through the legacy table. Two copies of ~200 lines of renderers would drift the moment either
 * branch changed.
 */
export function toUiColumns(columns) {
    return columns.map((_a) => {
        var { width, renderer } = _a, column = __rest(_a, ["width", "renderer"]);
        return (Object.assign(Object.assign({}, column), { renderer: renderer
                ? (props) => renderer(Object.assign(Object.assign({}, props), { key: String(props.index) }))
                : undefined }));
    });
}
export default toUiColumns;
